/* @flow */
import { StoreInformation } from "../../../../stores/SitecoreStoreInformationStore";
import { FsdAddressType } from "shared/src/types/customer/FsdAddress";
import type { Map } from "immutable";

export type ContactDetails = {
    phone: string;
    email: string;
};

export function getContactDetails(
    storeId: string | undefined | null,
    defaultContactDetails: ContactDetails | undefined | null,
    deliveryAddresses: Array<FsdAddressType>,
    sitecoreData: Map<string, StoreInformation> | undefined | null
): ContactDetails | undefined | null {
    if (!storeId) {
        return null;
    }
    const storeData = sitecoreData ? sitecoreData.get(storeId) : null;
    const deliveryStores = (deliveryAddresses ?? []).map((address) => address.deliveryStore);

    if (deliveryStores.includes(storeId)) {
        return defaultContactDetails;
    } else if (storeData) {
        return {
            phone: storeData.contactPhone,
            email: storeData.contactEmail
        };
    } else {
        // store is not delivery store and we have no contact information from sitecore.
        // Better show no contact information
        return null;
    }
}
